module.exports = __webpack_public_path__ + "img/sofort.21a6b30d.svg";